import {
    SETUP_PASSWORD,
    RESEND_OTP
} from "../config/api";
import { ISetUpPasswordRequest, ISetUpPasswordResendOTPRequest } from "../models/setupPassword";
import { baseService } from "./BaseService";

class SetPasswordService {
    public async setPassword(data: ISetUpPasswordRequest): Promise<any> {
        return baseService.post(SETUP_PASSWORD, data);
    }
    public async resendOTP(data: ISetUpPasswordResendOTPRequest): Promise<any> {
        return baseService.post(RESEND_OTP, data);
    }
}

export const setPasswordService = new SetPasswordService();